import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

interface Shortcut {
  keys: string[];
  /** Translation key for what it does. */
  action: string;
}

/** The app-wide shortcuts, opened from the account menu. */
@Component({
  selector: 'app-keyboard-shortcuts-dialog',
  templateUrl: './keyboard-shortcuts-dialog.component.html',
  styleUrls: ['./keyboard-shortcuts-dialog.component.scss'],
  imports: [MatDialogModule, MatButtonModule, TranslateModule],
})
export class KeyboardShortcutsDialogComponent {
  readonly shortcuts: Shortcut[] = [
    { keys: ['Alt', 'S'], action: 'shortcutSearch' },
    { keys: ['Alt', 'N'], action: 'shortcutAddNew' },
    { keys: ['Esc'], action: 'shortcutClose' },
  ];
}
